import React, { useContext, useRef } from "react";
import ActionsContext from "common/ActionsContext";
import LicenseHelpModal from "./Help";
import LicenseReport from "./Report";
import UploadClusterModal from "./UploadClusterModal.jsx";
import BqnContext from "common/BqnContext";
import {doFileChange, handleSaveFile, handleFileChange} from "./utils";
import { Header } from "common/Header";

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  const {
    clusterStatus: { mode },
  } = useContext(BqnContext); 
  const fileInputRef = useRef(null);

  const handleLoadClick = () => {
    if (mode === "cluster"){
      actions.send("open-upload");
    } else {
      fileInputRef.current.click();
    }
  };

  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li key="menu-open-help">
        <a
          data-loading-effect="pulse"
          data-toggle="cardloading"
          title="Help"
          onClick={() => actions.send("open-help")}
        >
          <i className="material-icons">help_outline</i>
        </a>
      </li>
      <li key="menu-refresh">
        <a
          onClick={() => actions.send("do-load")}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
      <li className="dropdown hidden-to-operators" key="menu-dropdown">
        <a
          className="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          title="Options"
        >
          <i className="material-icons">more_vert</i>
        </a>
        <ul className="dropdown-menu pull-right">
        <li key="menu-add-rule">
            <a onClick={handleLoadClick}>Load...</a>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </li>
        </ul>
      </li>
    </ul>
  );
};

const License = () => {
  const {
    clusterStatus: { mode },
  } = useContext(BqnContext); 
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="card">
        <Header title="License Status" contextMenu={<ContextMenu />} />
        <LicenseReport />
        <LicenseHelpModal />
        {mode === "cluster" ? <UploadClusterModal /> : null}
      </div>
    </div>
  );
};

export default License;
